import { useEffect, useState } from 'react'
import { gql } from '@apollo/client'
import { useTranslation } from 'react-i18next'

import client, { deserializeErrors } from 'apollo-client'
import EmptyScreen from 'packages/ui/EmptyScreen/EmptyScreen'

const OPERATION_HYPERIS = gql`
  query HyperisCreateSession($sfId: ID) {
    session: hyperisCreateSession(site_sf_id: $sfId) {
      id
      access_token
      refresh_token
      site_sf_id
    }
  }
`

const getFirstSite = () => {
  try {
    const {selected} = localStorage.getItem('sites')
      ? JSON.parse(localStorage.getItem('sites') || '')
      : { selected: [] }
    return [...selected]
      .sort((a, b) => a.label.localeCompare(b.label))[0]
  } catch (e) {
    console.error(e)
  }
}

const HyperisSSO = () => {
  const [error, setError] = useState<string | null>(null)
  const {t} = useTranslation()

  useEffect(() => {
    const redirect = async () => {
      try {
        const { data } = await client.mutate({
          mutation: OPERATION_HYPERIS,
          variables: {
            sfId: getFirstSite()?.sf_id,
          },
        });
        window.open(`${process.env.REACT_APP_HYPERIS_URL}/auth/session/${data.session.id}`, '_self')
      } catch (e) {
        // @ts-expect-error JSX - deserializeErrors accepts ApolloError but type definition is incomplete
        setError(deserializeErrors(e))
      }
    }

    redirect()
  }, [])


  if (error) return <EmptyScreen icon="gauge-high">{error}</EmptyScreen>
  return <EmptyScreen icon="gauge-high">{t('ui_elements.loading')}</EmptyScreen>
}

export default HyperisSSO